<template>
    <div>
        <el-form :model="formGet" status-icon ref="formGet" label-position="top" class="form-get" size="mini">
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label-position="left" label-width="70px" :label="$t('settings_statutoryInformation_barangay')" prop="barangay">
                    <el-input :placeholder="$t('settings_statutoryInformation_barangay')" v-model="formGet.barangay"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label-position="left" label-width="75px" :label="$t('settings_statutoryInformation_sss')" prop="sss">
                    <el-input placeholder="00-0000000-0" v-mask="'##-#######-#'" v-model="formGet.sss"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label-position="left" label-width="70px" :label="$t('settings_statutoryInformation_phic')" prop="phic">
                    <el-input placeholder="00-000000000-0" v-mask="'##-#########-#'" v-model="formGet.phic"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label-position="left" label-width="75px" :label="$t('settings_statutoryInformation_hdmf')">
                    <el-input placeholder="000000000000" v-mask="'############'" v-model="formGet.hdmf"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label-position="left" label-width="70px" :label="$t('settings_statutoryInformation_tin')" prop="tin">
                    <el-input placeholder="000-000-000-000" v-mask="'###-###-###-###'" v-model="formGet.tin"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label-position="left" label-width="75px" :label="$t('settings_statutoryInformation_rdoCode')">
                    <el-input :placeholder="$t('settings_statutoryInformation_rdoCode')" v-model="formGet.rdo"></el-input>
                    <span>{{$t('settings_statutoryInformation_revenueDistrictOfficeOfTheBir')}}</span>
                </el-form-item>
            </el-col>
        </el-row>
        <el-form-item>
            <el-button @click="save('formGet')" class="modal__btn" type="primary" plain size="small">{{$t('settings_companyAdditionalInfo_save')}}</el-button>
        </el-form-item>
        </el-form>
    </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'setting-company-statutory-info',
    data() {
      return {
        formGet:{
          barangay: null,
          sss: null,
          phic: null,
          hdmf: null,
          tin: null,
          rdo: null
        }
      }
    },
    methods:{
      async getCompanyAditionalInfo(tabName){
        try{
          let loader = this.$loading.show();
          await this.item();
          loader.hide()
        }catch(err){
          console.log(err)
        }
      },
      item(){
        return new Promise ((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/companies/itemCompanyStaturyInfo?companyId=${this.$route.query.companyId}`)
            .then(response => {
              if(response.data.item){
                this.formGet.barangay = response.data.item.barangay;
                this.formGet.sss = response.data.item.sss;
                this.formGet.phic = response.data.item.phic;
                this.formGet.hdmf = response.data.item.hdmf;
                this.formGet.tin = response.data.item.tin;
                this.formGet.rdo = response.data.item.rdo;
                console.log(response.data)
              }
              resolve(response.data)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error)
            });
        });
      },
      save(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            const data = {
                barangay: this.formGet.barangay,
                sss: this.formGet.sss,
                phic: this.formGet.phic,
                hdmf: this.formGet.hdmf,
                tin: this.formGet.tin,
                rdo: this.formGet.rdo
            };
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/companies/saveStaturyInfo?companyId=${this.$route.query.companyId}`, data)
              .then(response => {
                this.$message({
                  type: 'success',
                  message: this.$t('settings_statutoryInformation_companyStatutoryInfoSaved')
                });
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
          }
        });
      },
    }
  }
</script>

<style lang="less" scoped>
    .form-get{
        width:700px;
    }
</style>
